'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { getDevice } from '#pplx/frontend/platform-components/device.js';
import { getEnv } from '#pplx/frontend/platform-components/env.js';
import { WebPlatformContext } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { memo, useMemo } from 'react';
export const WebPlatformProvider = memo(function WebPlatformProvider({ children, userAgent, hostname, serverEnvironment }) {
    const platform = useMemo(() => ({
        device: getDevice(userAgent),
        env: getEnv(hostname, serverEnvironment),
        hostname,
    }), [userAgent, hostname, serverEnvironment]);
    return _jsx(WebPlatformContext.Provider, { value: platform, children: children });
});
//# sourceMappingURL=WebPlatformProvider.js.map